import * as React from "react"
import { Button, Form, Input } from "antd"
import { WrappedFormUtils } from "antd/lib/form/Form"

type Props = {
    form: WrappedFormUtils
    isProcessing: boolean
    onSubmit: (email: string) => void
}

class PasswordResetRequestForm extends React.Component<Props> {
    onSubmit = e => {
        e.preventDefault()
        this.props.form.validateFields((err, values) => {
            if (!err) {
                this.props.onSubmit(values.email)
            }
        })
    }

    render() {
        const emailOptions = {
            validateTrigger: "onBlur",
            rules: [
                {
                    type: "email",
                    message: "Please enter valid email address",
                },
                {
                    required: true,
                    message: "Email address cannot be empty",
                },
            ],
        }
        return (
            <div
                className="password-reset-form"
                style={{
                    marginTop: "2rem",
                }}>
                <Form onSubmit={this.onSubmit}>
                    <Form.Item
                        style={{
                            marginBottom: "1rem",
                        }}
                        className="big-form-item">
                        {this.props.form.getFieldDecorator(
                            "email",
                            emailOptions
                        )(<Input type="email" placeholder="Email Address" />)}
                    </Form.Item>

                    <Form.Item
                        style={{
                            marginBottom: "1rem",
                        }}>
                        <Button
                            className="fill big-button"
                            type="primary"
                            htmlType="submit"
                            size="large"
                            loading={this.props.isProcessing}>
                            Change Password
                        </Button>
                    </Form.Item>
                </Form>
            </div>
        )
    }
}

export default Form.create()(PasswordResetRequestForm)
